const BASE_SELECTOR: string = '[data-mapgroup]';
const maplistTemplate = require('./views/maplist.handlebars');
const mapSelectTemplate = require('./views/mapselectbox.handlebars');
import { Sortable, Plugins } from '@shopify/draggable/lib/es5/draggable.bundle';

export class MapGroupUI {
  private sortable: any = false;

  public constructor(private $base: JQuery) {}

  /**
   * Init Drag & Drop
   */
  private initDraggable(callback: (evt) => {}) {
    const containers = document.querySelectorAll('.mapgroup__list');
    const containerSelector = '.mapgroups';

    const Classes = {
      draggable: 'mapgroup__item',
      capacity: 'draggable-container-parent--capacity',
    };

    if (containers.length === 0) {
      return false;
    }

    if (!this.sortable) {
      this.sortable = new Sortable(containers, {
        draggable: `.${Classes.draggable}`,
        mirror: {
          constrainDimensions: true,
          appendTo: containerSelector,
        },
        plugins: [Plugins.ResizeMirror],
      });

      this.sortable.on('sortable:stop', (evt) => {
        if (this.countMaps() > 0) {
          this.$base.find('.mapgroup__placeholder').parent().hide();
        } else {
          this.$base.find('.mapgroup__placeholder').parent().show();
        }

        callback(evt);
      });
    }
  }

  public getSelectedMaps(): string[] {
    const data = [];
    const elements = this.$base.find('.mapgroup__list--selection .mapgroup__item').not('.mapgroup__item--placeholder');
    elements.map((index, element) => {
      const id = $(element).data('id');
      data.push(id);
    });
    return data;
  }

  public countMaps(): number {
    return this.$base.find('.mapgroup__list--selection .mapgroup__item').not('.mapgroup__item--placeholder').length;
  }

  /**
   * Render list of maps
   * @param list
   */
  public renderMapList(list, onMapDrop: () => {}) {
    this.$base.find('.mapgroup__choose .mapgroup__list').html(maplistTemplate({list: list}));
    this.initDraggable(onMapDrop);
  }

  /**
   *  Render selected maps
   */
   public renderSelectedMaps(list) {
     this.$base.find('.mapgroup__list--selection').find('.mapgroup__item').not('.mapgroup__item--placeholder').remove();
     this.$base.find('.mapgroup__list--selection').prepend(maplistTemplate({list: list}));
   }

  /**
   * Render <select></select> for mapgroups
   */
  public renderSelect(groups, callback: () => {}) {
    this.$base.find('[data-map-group-select]').html(mapSelectTemplate({groups: groups}))
    callback();
  }

  /**
   * Listen to mapgroup change
   * @param callback
   */
  public onMapGroupChange(callback: (value: string) => {}) {
    this.$base.find('[data-map-group-select]').find('select').on('change', (ev) => callback($(ev.currentTarget).val() as string))
  }

  /**
   * Listen to destroy button click
   * @param callback
   */
  public onDestroyButtonClick(callback: () => {}) {
    this.$base.find('[data-destroy]').on('click', () => callback());
  }

  /**
   * Listen to create button click
   * @param callback
   */
  public onCreateButtonClick(callback: () => {}) {
    this.$base.find('[data-create]').on('click', () => callback());
  }

  public onSaveButtonClick(callback: () => {}) {
    this.$base.find('[data-save]').on('click', () => callback());
  }

  public showPlaceholder() {
    $('.mapgroup__item.mapgroup__item--placeholder').show();
  }

  /**
   * Listen to create-map-group button
   */
  public onAddMapGroupSubmit(callback: (value: string) => {}) {
    this.$base.find('[data-new-mapgroup-form]').on('submit', (ev) => {
      ev.preventDefault();
      callback(this.$base.find('[data-new-mapgroup-name]').val() as string);
    });
  }

  /**
   * Return current value of mapgroup selectfield
   * @return value - string
   */
  public getCurrentMapGroup() : string {
    return this.$base.find('[data-map-group-select]').find('select').val() as string;
  }

  /**
   * Toggle input to create new map group
   */
  public toggleAddMapGroupForm() {
    this.$base.find('.create-mapgroup__wrapper').toggleClass('is-visible');
    this.$base.find('.create-mapgroup__wrapper input').focus();
  }

  public setValueOfMapGroupSelect(val: string) {
    window.setTimeout(() => this.$base.find('[data-map-group-select]').find('select').val(val), 200);
  }

  public toggleSaveButton(state: boolean) {
    if (state) {
      this.$base.find('[data-save]').attr('disabled', 'disabled');
    } else {
      this.$base.find('[data-save]').removeAttr('disabled');
    }
  }
}

export function createMapGroupInstances() : MapGroupUI[] {
  const instances: MapGroupUI[] = [];
  $(BASE_SELECTOR).each((index, item) => {
    instances.push(new MapGroupUI($(item)));
  });

  return instances;
}
